module.exports = __webpack_public_path__ + "media/images/flags/16/Ghana-e21dbfafc91565a2a5dccc146cd11bfd.png";